import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent, ModalIconTitleComponent } from '@libs/common/components';
import { MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';

@Component({
  selector: 'ui-product-availability-dialog-form',
  imports: [ModalIconTitleComponent, MatDialogContent, MatDialogActions, ButtonComponent, MatDialogClose],
  templateUrl: './product-availability-dialog-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-availability-dialog-form.component.scss',
})
export class ProductAvailabilityDialogFormComponent {
}
